import { FC } from 'react';
import { Grid, styled, Tooltip } from '@mui/material';
import { useAppSelector } from '@/redux/hooks';
import { selectAvailPlatform } from '@/redux/selectors/constantsSelectors';
import PlatformIcon, { PlatformIconStyled, sizesMap } from '@/components/_common/Table/Calendar/CalendarSharedComponents/PlatformIcon';

type IconSize = 'small' | 'medium';

interface Props {
  platforms: string[];
  limit?: number;
  iconSize?: IconSize;
}

const PlatformsList: FC<Props> = ({ platforms, limit = 3, iconSize = 'medium' }) => {
  const allPlatforms = useAppSelector(selectAvailPlatform);

  return (
    <PlatformsWrapper iconSize={iconSize}>
      {platforms.slice(0, limit).map((name, index) => {
        return <PlatformIcon key={index} name={name} size={iconSize} />;
      })}
      {platforms.length > limit && (
        <Tooltip
          title={platforms.slice(limit).map((name, index) => (
            <RestPlatformsGridStyled key={index} container alignItems="center" gap={1}>
              <Grid item>
                <PlatformIcon name={name} disableTooltip />
              </Grid>
              <Grid item xs sx={{ pr: 1 }}>
                {allPlatforms[name]}
              </Grid>
            </RestPlatformsGridStyled>
          ))}
          placement="top"
        >
          <PlatformIconStyled hasImage={false}>+{platforms.length - limit}</PlatformIconStyled>
        </Tooltip>
      )}
    </PlatformsWrapper>
  );
};

export default PlatformsList;

const PlatformsWrapper = styled('div')<{ iconSize: IconSize }>`
  ${({ iconSize }) => {
    return `
      display: flex;
    
      & > *:not(:last-child) {
        margin-right: -${sizesMap[iconSize] / 2}px;
      }
    `;
  }}
`;

const RestPlatformsGridStyled = styled(Grid)`
  &:not(:last-child) {
    margin-bottom: ${({ theme }) => theme.spacing(1)};
  }
`;
